import { useTranslation } from 'react-i18next'

import {
  QA_NAME_SHOW_LESS_BUTTON,
  QA_NAME_SHOW_MORE_BUTTON,
} from '../../../../../../constants/qa'
import { useReadMore } from '../../../../../../hooks'
import Button, { BUTTON_HEIGHT_24 } from '../../../../../Button'
import Text from '../../../../../Text'
import { useApplicantProfileContext } from '../../../RentalPortalApplicantProfile.hooks'
import {
  APPLICANT_IDENTITY_MESSAGE_CLAMP_LINES,
  QA_NAME_APPLICANT_IDENTITY_MESSAGE,
} from '../ApplicantIdentityWidget.constants'
import {
  getApplicantIdentityMessageValue,
  getIsApplicantMessageMasked,
} from '../ApplicantIdentityWidget.utils'

import * as styles from './ApplicantIdentityWidgetMessage.module.css'

function ApplicantIdentityWidgetMessage() {
  const { t } = useTranslation()

  const { applicantData } = useApplicantProfileContext()

  const { handleClickReadMore, isReadMore, showReadMore, textRef } =
    useReadMore({
      maxLines: APPLICANT_IDENTITY_MESSAGE_CLAMP_LINES,
      textData: applicantData?.message?.value,
    })

  const isMessageMasked = getIsApplicantMessageMasked(applicantData)

  return (
    <>
      <Text isSecondary className={styles.label}>
        {t('RentalPortal.ApplicantProfileIdentityMessageLabelKey')}
      </Text>
      <div className={styles.message}>
        <Text
          className={styles.text}
          disabled={isMessageMasked}
          isSecondary={isMessageMasked}
          qaName={QA_NAME_APPLICANT_IDENTITY_MESSAGE}
          ref={textRef}
        >
          {getApplicantIdentityMessageValue({ applicantData, t })}
        </Text>
        {showReadMore ? (
          <Button.Contained
            isGrey
            height={BUTTON_HEIGHT_24}
            qaName={
              isReadMore ? QA_NAME_SHOW_LESS_BUTTON : QA_NAME_SHOW_MORE_BUTTON
            }
            text={t(
              isReadMore
                ? 'Notification.CommonReadLessBtnKey'
                : 'Notification.CommonReadMoreBtnKey'
            )}
            onClick={handleClickReadMore}
          />
        ) : null}
      </div>
    </>
  )
}

export default ApplicantIdentityWidgetMessage
